import { Component } from '@angular/core';

@Component({
  selector: 'asi-divider',
  template: '<span class="asi-divider"></span>'
})
export class AsiDividerComponent {
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/divider/asi-divider.component.ts